import { render, staticRenderFns } from "./AnnualItem.vue?vue&type=template&id=50e3f896"
import script from "./AnnualItem.vue?vue&type=script&lang=js"
export * from "./AnnualItem.vue?vue&type=script&lang=js"
import style0 from "./AnnualItem.vue?vue&type=style&index=0&id=50e3f896&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports